import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import QrcodeVue from 'qrcode.vue';


const __default__ = {
  name: "QrCodeWidget",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    config: {}
  },
  setup(__props: any) {

const props = __props;

const qrSize = computed(() =>
  Math.max(props.config.width, props.config.height)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(QrcodeVue, {
    value: _ctx.config.url,
    level: _ctx.config.level,
    "render-as": "svg",
    background: _ctx.config.backgroundColor,
    foreground: _ctx.config.color,
    gradient: _ctx.config.showGradiant,
    "gradient-type": _ctx.config.gradiantType,
    "gradient-start-color": _ctx.config.startColor,
    "gradient-end-color": _ctx.config.endColor,
    size: qrSize.value
  }, null, 8, ["value", "level", "background", "foreground", "gradient", "gradient-type", "gradient-start-color", "gradient-end-color", "size"]))
}
}

})